// extracted by mini-css-extract-plugin
export default {"borderContainer":"JobModal_borderContainer__+bH77"};